import React from "react";
import "./style.scss";

export type EstablishCheckProps = {
  name: string;
  text: string;
  isChecked: boolean;
  setIsChecked: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const EstablishCheck = (props: EstablishCheckProps) => {
  const { name, text, isChecked, setIsChecked } = props;
  return (
    <label className="establishRadio">
      <input
        className="establishRadio_input"
        name={name}
        type="checkbox"
        checked={isChecked}
        onChange={setIsChecked}
      />
      <span className="establishRadio_text">{text}</span>
    </label>
  );
};
